module.exports = __webpack_public_path__ + "img/藁本.1357397b.jpg";